<script>
import ClientesService from '@/services/clientes.service';
import { PaginacionDefault, Rol, ESTADO_CONTADOR, ESTADO_REGISTRO_CONTADOR, EstadoRegistro, RegistroEstadoContador } from '@/constants/global';
import Utils from '@/functions/utils';
import authService from '@/services/auth.service';
import spinnerService from '@/services/spinner.service';

export default {

  data() {
    return {
      loading: false,
      roles: Rol,
      asesores: [],
      estados: ESTADO_CONTADOR,
      registros: ESTADO_REGISTRO_CONTADOR,
      errores: {},
      usuario: authService.getUser(),
      contadordb: {},
      contador: {
        documento: null,
        nombre: null,
        estado: null,
        confirmacion: null
      }
    }
  },
  async mounted() {
    const id = this.$route.params.id;
    if (id && (isNaN(id) || id <= 0)) {
      this.$router.push({
        path: '/not-found'
      });
      return;
    }
    await this.getUsuarios();
    await this.getContadorPorId(id);

  },
  methods: {
    async getUsuarios() {
      let res = await ClientesService.getUsuarios(PaginacionDefault.FILTRO, PaginacionDefault.PAGINA, PaginacionDefault.SIZE, PaginacionDefault.ESTADO);
      let values = res.data || [];
      this.asesores = values.map(map => {
        return { label: map.nombre, value: map.id }
      });
    },
    btnCancelar_click() {
      this.$router.go(-1);
    },
    async getContadorPorId(id) {
      let res = await ClientesService.getContadorPorId(id);
      this.contadordb = res;
      this.contador.id = res.id;
      this.contador.idAsesor = res.idAsesor;
      this.contador.documento = res.documento;
      this.contador.nombre = res.razonSocial;
      this.contador.afiliado = res.afiliado;
      this.contador.ciudad = res.ciudad;
      this.contador.direccion = res.direccion;
      this.contador.telefono = res.telefono;
      this.contador.correo = res.correo;
      this.contador.ocupacion = res.ocupacion;
      this.contador.estado = res.estado;
      this.contador.confirmacion = res.confirmacion;
    },

    async btnGuardar_click() {
      if (this.loading) return;
      //VALIDACIONES
      this.errores.idasesor = Rol.ADMINISTRADOR == this.usuario.rol
        && (this.contador.idAsesor == null || this.contador.idAsesor == -1);
      this.errores.documento = this.contador.documento == null || this.contador.documento.trim() == '';
      this.errores.nombre = this.contador.nombre == null || this.contador.nombre.trim() == '';
      this.errores.ciudad = this.contador.ciudad == null || this.contador.ciudad.trim() == '';
      this.errores.direccion = this.contador.direccion == null || this.contador.direccion.trim() == '';
      this.errores.telefono = this.contador.telefono == null || this.contador.telefono.trim() == '';
      this.errores.correo = this.contador.correo == null || this.contador.correo.trim() == '';

      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) return;

      this.loading = true;
      spinnerService.show();
      try {
        let obj = {
          Id: this.contador.id,
          IdAsesor: this.contador.idAsesor,
          Documento: this.contador.documento,
          RazonSocial: this.contador.nombre,
          Estado: this.contador.estado,
          Confirmacion: this.contador.confirmacion,
          Ocupacion: this.contadordb.ocupacion,

          Ciudad: this.contador.ciudad,
          Direccion: this.contador.direccion,
          Telefono: this.contador.telefono,
          Correo: this.contador.correo,
          FechaConfirmacion: this.contador.confirmacion == RegistroEstadoContador.CONFIRMADO ? new Date() : null,          

          FechaCreacion: this.contadordb.fechaCreacion,
          FechaRegistro: this.contadordb.fechaRegistro,
          Terminos: this.contadordb.terminos,
          Afiliado: this.contadordb.afiliado,
          LogEstado: EstadoRegistro.ACTIVO
        };

        await ClientesService.updateContador(obj.Id,obj);
        Utils.mostrarMensajeExito('El revendedor se ha guardado exitosamente');
        this.loading = false;
        this.$router.push({
          path: `/info/revendedores`
        });
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeError(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }

    }
  }
};

</script>
<template>
  <div class="space"></div>
  <div class="container conts">
    <div class="row">
      <div class="col"></div>
      <div class="col-sm-9">
        <div class="recuadro bg-white mt-5 mb-5">
          <div class="text-center head bg-primary bg-gradient text-white p-4">
            <h1>EDITAR CONTADOR SMART</h1>
          </div>
          <div class="card-body p-5">
            <form id="regis" action="/editarRecomendador" method="POST">
              <input type="hidden" name="id_cont" id="id_cont" value="<%=contador.id_cont%>">
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="asesor" class="form-control-lg">Asesor de Ventas</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="cont_asesor" id="cont_asesor" class="req form-select form-control-lg"
                      v-model="contador.idAsesor" :disabled="usuario.rol != roles.ADMINISTRADOR"
                      v-bind:class="{ 'invalid': errores.idasesor }">
                      <option value="-1">Seleccione un asesor</option>
                      <option v-for="asesor in asesores" :key="asesor.value" :value="asesor.value">
                        {{ asesor.label }}
                      </option>
                    </select>

                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Información del contador SMART</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="cont_dni" class="form-control-lg">DNI</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_dni" id="cont_dni"
                      v-model="contador.documento" v-bind:class="{ 'invalid': errores.documento }" maxlength="11">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="cont_nombre" class="form-control-lg">Nombre Completo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_nombre" id="cont_nombre"
                      v-model="contador.nombre" v-bind:class="{ 'invalid': errores.nombre }" maxlength="255">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="ciudad" class="form-control-lg">Ciudad</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_ciudad" id="cont_ciudad"
                      v-model="contador.ciudad" v-bind:class="{ 'invalid': errores.ciudad }" maxlength="255">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="direccion" class="form-control-lg">Dirección</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_direccion" id="cont_direccion"
                      v-model="contador.direccion" v-bind:class="{ 'invalid': errores.direccion }" maxlength="255">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="cont_telefono" class="form-control-lg">Teléfono</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_telefono" id="cont_telefono"
                      v-model="contador.telefono" v-bind:class="{ 'invalid': errores.telefono }" maxlength="255">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="cont_email" class="form-control-lg">E-mail</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_email" id="cont_nombre"
                      v-model="contador.correo" v-bind:class="{ 'invalid': errores.correo }" maxlength="255">
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Estado del registro</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="estado" class="form-control-lg">Estado</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="cont_estado" id="cont_estado" class="form-select form-control-lg"
                      v-model="contador.estado">

                      <option v-for="estado in estados" :key="estado.id" :value="estado.id"
                        :disabled="estado.id == 1 && contadordb.estado != 1">
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="confirmacion" class="form-control-lg">Confirmación de registro</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="cont_confirm" id="cont_confirm" class="form-select form-control-lg"
                      v-model="contador.confirmacion">
                      <option v-for="registro in registros" :key="registro.id" :value="registro.id">
                        {{ registro.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <input type="hidden" name="cont_ocupacion" id="cont_ocupacion" value="Contador">
                  <input type="hidden" name="cont_fec_confirm" id="cont_fec_confirm">
                  <div class="col"><a @click="btnCancelar_click" class="btn btn-danger form-control btn-lg">Cancelar</a>
                  </div>
                  <div class="col"></div>
                  <div class="col"><button type="button" id="guardar" class="btn btn-primary form-control btn-lg"
                      @click="btnGuardar_click">Guardar</button></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col"></div>
  </div>
</div></template>